import dayjs from 'dayjs';

/**
 * 現在のunix時間(ミリ秒)にindexの値を加算して返す。
 * 通告作成タブでのidはunix時間だが、テンプレートを複数選択した場合は重複するためこのメソッドを使用する。
 *
 * @param {integer} index
 * @return {integer}
 */
const generateNoticeFrameId = (index) => {
  return dayjs().add(index, 'millisecond').valueOf();
};

export default generateNoticeFrameId;
